import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { sfHeadline } from './sectionHelpers';

const TrustBar: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  const items = (c.items || []) as Array<{ image_url?: string; alt?: string; name?: string }>;
  const style = c.style || 'grayscale';
  const headingText = sfHeadline(c, 'Trusted by leading companies');

  return (
    <section style={{ padding: '40px 24px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        {headingText && (
          <InlineEditText
            tag="p"
            controlKey="heading"
            style={{ textAlign: 'center', color: '#64748b', marginBottom: 24, fontSize: '0.875rem' }}
          >
            {headingText}
          </InlineEditText>
        )}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 32, flexWrap: 'wrap' }}>
          {items.map((item, i) => {
            const label = item.alt || item.name || '';
            return item.image_url ? (
              <img key={i} src={item.image_url} alt={label} style={{ height: 40, filter: style === 'grayscale' ? 'grayscale(100%)' : 'none', opacity: style === 'grayscale' ? 0.6 : 1 }} />
            ) : label ? (
              <span key={i} style={{
                fontWeight: 700, fontSize: '1rem',
                color: style === 'grayscale' ? '#94a3b8' : 'var(--brand-primary, #2563eb)',
                letterSpacing: '-0.01em', opacity: style === 'grayscale' ? 0.7 : 1,
                padding: '6px 12px',
                border: `1px solid ${style === 'grayscale' ? '#e2e8f0' : 'rgba(37,99,235,0.2)'}`,
                borderRadius: 6,
              }}>{label}</span>
            ) : null;
          })}
        </div>
      </div>
    </section>
  );
};
export default TrustBar;
